// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"yp-z","imageAndVideoCount":"zp-z","imageAndVideoContainer":"Ap-z","viewAllReviews":"Bp-z"};